const ThemeRouteName = {
  THEME_MANAGER: 'themeManager',
};

export default ThemeRouteName;
